import {
  MonitorDot,
  ScanLine,
  LineChart,
  Store,
  Truck,
  FileBarChart,
  Settings,
  Settings2,
  User,
  CircleUser,
  HandIcon,
  BookCheck,
  Wallet,
  HelpingHand,
  UserCheck,
  File,
  Pencil,
  ShoppingBag,
  PackageCheck,
  BarChart4,
  Tag
} from "lucide-react";

const menuData: any = [
  {
    label: 'admin panel',
    isTitle: true,
  },
  {
    id: "dashboard",
    label: 'Dashbord',
    link: "/dashbordNew",
    icon: <MonitorDot />,
  },
  {
    id: "dashboard",
    label: 'Purchase IC',
    link: "/AddCollection",
    icon: <ShoppingBag />,
  },
  {
    id: "dashboard",
    label: 'Sale',
    link: "/CustomerClosing",
    icon: <	Tag />,
  },
    {
    id: "dashboard",
    label: 'Delivery',
    link: "/CustomerClosing",
    icon: <	Tag />,
  },
  {
    id: "dashboard",
    label: 'Deals',
    link: "/#",
    icon: <UserCheck />,
    subItems: [
      {
        id: "dashboard",
        label: 'Deposit',
        link: "/AddDeposit",
        icon: <User />,
      },
      {
        id: "dashboard",
        label: 'Purchase',
        link: "/AddPurchase",
        icon: <User />,
      },
      {
        id: "dashboard",
        label: 'Metal Sale',
        link: "/addSale",
        icon: <User />,
      },


    ]
  },
  {
    id: "dashboard",
    label: 'Shipment',
    link: "/Shipment",
    icon: <PackageCheck />,
  },
  // {
  //   id: "dashboard",
  //   label: 'Delivery',
  //   link: "/DeliveryShipment",
  //   icon: <Truck />,
  // },
  {
    id: "dashboard",
    label: 'Reports',
    link: "/#",
    icon: <BarChart4 />,
    subItems: [

      {
        id: 'Settings',
        label: 'Finance',
        link: '/apps-users-list',
        parentId: "dashboard"
      },

    ]
  },

  // {
  //   id: "dashboard",
  //   label: 'Customers',
  //   link: "/apps-users-list",
  //   icon: <User />,
  // },
  // {
  //   id: "dashboard",
  //   label: 'Shipment',
  //   link: "/Shipment",
  //   icon: <Truck />,
  // },


  // {
  //   id: "dashboard",
  //   label: 'Transactions',
  //   link: "/#",
  //   icon: <BookCheck />,
  //   subItems: [

  //     {
  //       id: 'Settings',
  //       label: 'Add Collection',
  //       link: '/AddCollection',
  //       parentId: "dashboard"
  //     },
  //     {
  //       id: 'Settings',
  //       label: 'Deposit',
  //       link: '/AddDeposit',
  //       parentId: "dashboard"
  //     },

  //     {
  //       id: 'Settings',
  //       label: 'Sale',
  //       link: '/addSale',
  //       parentId: "dashboard"
  //     },

  //     {
  //       id: 'Settings',
  //       label: 'Sales Completed ',
  //       link: '/CustomerClosing',
  //       parentId: "dashboard"
  //     }

  //   ]
  // },
  // {
  //   id: "dashboard",
  //   label: 'Deals',
  //   link: "/#",
  //   icon: <UserCheck />,
  //   subItems: [

  //     {
  //       id: 'Settings',
  //       label: 'Purchase',
  //       link: '/AddPurchase',
  //       parentId: "dashboard"
  //     },

  //   ]
  // },
  // {
  //   id: "dashboard",
  //   label: 'User Creations',
  //   link: "/#",
  //   icon: <Pencil />,
  //   subItems: [

  //     {
  //       id: 'Settings',
  //       label: 'Manager',
  //       link: '/managerCreation',
  //       parentId: "dashboard"
  //     },
  //     {
  //       id: 'Settings',
  //       label: 'Vendor',
  //       link: '/VendorCreation',
  //       parentId: "dashboard"
  //     },
  //     {
  //       id: 'Settings',
  //       label: 'Customer Creation',
  //       link: '/AddCustomers',
  //       parentId: "dashboard"
  //     },
  //     {
  //       id: 'Settings',
  //       label: 'Shipment',
  //       link: '/AddShipment',
  //       parentId: "dashboard"
  //     },

  //   ]
  // },
  {
    id: "dashboard",
    label: 'Settings',
    link: "/#",
    icon: <Settings />,
    subItems: [
      {
        id: 'Settings',
        label: 'Manager',
        link: '/managerCreation',
        parentId: "dashboard"
      },
      {
        id: 'Settings',
        label: 'Vendor',
        link: '/VendorCreation',
        parentId: "dashboard"
      },
      {
        id: 'Settings',
        label: 'Customer Creation',
        link: '/AddCustomers',
        parentId: "dashboard"
      },
      {
        id: 'Settings',
        label: 'Shipment',
        link: '/AddShipment',
        parentId: "dashboard"
      },
      {
        id: 'Settings',
        label: 'Group',
        link: '/AddGroup',
        parentId: "dashboard"
      },


    ]
  },

  // {
  //   id: "dashboard",
  //   label: 'Vendor',
  //   link: "/vendorData",
  //   icon: <Store />,
  // },





];

export { menuData };